// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d0b821f9","498":"164669a1","703":"e5e07998"}[chunkId] + ".chunk.js";
};